import React from 'react';
import jQuery from 'jquery';

function debouncer(timeout) {
	const timer = {handler: null};
	return function (fn) {
		clearTimeout(timer.handler);
		timer.handler = setTimeout(fn, timeout);
	};
}

export class SearchWidget extends React.Component {
	debouncer = debouncer(350);

	constructor(props) {
		super(props);
		this.state = {
			attributes: JSON.parse(JSON.stringify(props.attributes)), // Clone data
			value: props.attributes.value || null,
			results: []
		};
		delete this.state.attributes.value;
	}

	onChange(value) {
		this.setState({value: value});
		/*this.debouncer(() =>
			jQuery.ajax(this.props.endpoint, {
				dataType: 'json',
				success: response => this.setState({results: response}),
				failure: () => this.setState({results: []})
			})
		);*/
	}

	render() {
		return (
			<div>
				<div className="input">
					<input {...this.props.attributes} autoComplete="off" value={this.state.value} onChange={e => this.onChange(e.target.value)} />
				</div>
				<div className="button">
					<button type="submit"><i className="fa fa-search search-icon" aria-hidden="true" /></button>
				</div>
				{/*this.state.results.length > 0 &&
					<div className="search-results">
						<div className="search-result-content">
							{this.state.results.map(({title, link}) => <a href={link || '#'} className="search-result">{title}</a>)}
						</div>
					</div>
				*/}
			</div>
		);
	}
}
